import axios from 'axios';

import { axiosHeader, getGlobalRootUrl } from 'common/helpers/apiHelper';

export const asyncPingV1Api = async () => {
  await axios.post(`${getGlobalRootUrl()}/ping`, null, axiosHeader());
};
